import setupUFOGlobalErrorHandler from '@atlassian/react-ufo/global-error-handler';

export { sinkErrorHandler } from '@atlassian/react-ufo/global-error-handler';
export default setupUFOGlobalErrorHandler;
